import { useMutation } from 'react-query';
import {
  getAllFaceRecognitionEventByLicenseAsync,
  getAllFaceRecognitionEventCountByLicenseAsync,
  getFaceRecognitionEventByIdAsync,
} from '../../index';

export const useGetFaceRecognitionEventByIdAsync = () =>
  useMutation(getFaceRecognitionEventByIdAsync);

export const useGetAllFaceRecognitionEventByLicenseAsync = () =>
  useMutation(getAllFaceRecognitionEventByLicenseAsync);

export const useGetAllFaceRecognitionEventCountByLicenseAsync = () =>
  useMutation(getAllFaceRecognitionEventCountByLicenseAsync);
